import * as rows from 'common/constants/financials';
import { largeCurrencyFormat } from 'common/formats/formats';
import { baseRowConfig } from 'pages/Financials/data';
import AdjustEBITDAChip from 'pages/Financials/income-statement/components/AdjustEBITDAChip';

const INDENTED_CLASSNAME = 'subtitle-indented';
const INDENTED_BOLD_CLASSNAME = `bold-row ${INDENTED_CLASSNAME}`;

const rowConfig = (isDisabled: boolean) => [
  ...baseRowConfig,
  {
    value: rows.TOTAL_REVENUE_TITLE,
    alias: rows.TOTAL_REVENUE_ALIAS,
    hidden: false,
    readOnly: isDisabled,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    allowNegativeValue: true,
    allowEmptyValues: true,
  },
  {
    value: rows.TOTAL_SALES_COST_TITLE,
    alias: rows.TOTAL_SALES_COST_ALIAS,
    hidden: false,
    readOnly: isDisabled,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    allowNegativeValue: true,
    allowEmptyValues: true,
  },
  {
    value: rows.GROSS_PROFIT_TITLE,
    alias: rows.GROSS_PROFIT_ALIAS,
    hidden: false,
    readOnly: true,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    className: INDENTED_CLASSNAME,
    validExpr: rows.GROSS_PROFIT_EXPR,
    allowEmptyValue: true,
    skipIfNullProviders: true,
  },
  {
    value: rows.OPERATING_EXPENSES_TITLE,
    alias: rows.OPERATING_EXPENSES_ALIAS,
    hidden: false,
    readOnly: isDisabled,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    allowNegativeValue: true,
    allowEmptyValues: true,
  },
  {
    value: rows.EBITDA_TITLE,
    alias: rows.EBITDA_ALIAS,
    hidden: false,
    readOnly: true,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    className: INDENTED_BOLD_CLASSNAME,
    hasSubRows: true,
    showSubRows: true,
    sideComponent: <AdjustEBITDAChip />,
    validExpr: rows.EBITDA_EXPR,
    allowEmptyValue: true,
    skipIfNullProviders: true,
  },
  {
    value: rows.ADJUSTED_EBITDA_TITLE,
    alias: rows.ADJUSTED_EBITDA_ALIAS,
    hidden: false,
    readOnly: isDisabled,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    allowNegativeValue: true,
    allowEmptyValues: true,
    parent: rows.EBITDA_ALIAS,
  },
  {
    value: rows.DEPRECIATION_EXPENSE_TITLE,
    alias: rows.DEPRECIATION_EXPENSE_ALIAS,
    hidden: false,
    readOnly: isDisabled,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    allowNegativeValue: true,
    allowEmptyValues: true,
  },
  {
    value: rows.AMORTIZATION_EXPENSE_TITLE,
    alias: rows.AMORTIZATION_EXPENSE_ALIAS,
    hidden: false,
    readOnly: isDisabled,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    allowNegativeValue: true,
    allowEmptyValues: true,
    dbDecimalPlaces: 15,
  },
  {
    value: rows.EBIT_TITLE,
    alias: rows.EBIT_ALIAS,
    hidden: false,
    readOnly: true,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    className: INDENTED_BOLD_CLASSNAME,
    validExpr: rows.EBIT_EXPR,
    allowEmptyValue: true,
    skipIfNullProviders: true,
  },
  {
    value: rows.INTEREST_EXPENSE_TITLE,
    alias: rows.INTEREST_EXPENSE_ALIAS,
    hidden: false,
    readOnly: isDisabled,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    allowNegativeValue: true,
    allowEmptyValues: true,
  },
  {
    value: rows.OTHER_EXPENSE_TITLE,
    alias: rows.OTHER_EXPENSE_ALIAS,
    hidden: false,
    readOnly: isDisabled,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    allowNegativeValue: true,
    allowEmptyValues: true,
  },
  {
    value: rows.PRETAX_INCOME_TITLE,
    alias: rows.PRETAX_INCOME_ALIAS,
    hidden: false,
    readOnly: true,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    className: INDENTED_CLASSNAME,
    validExpr: rows.PRETAX_INCOME_EXPR,
    allowEmptyValue: true,
    skipIfNullProviders: true,
  },
  {
    value: rows.INCOME_TAXES_TITLE,
    alias: rows.INCOME_TAXES_ALIAS,
    hidden: false,
    readOnly: isDisabled,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    allowNegativeValue: true,
    allowEmptyValues: true,
  },
  {
    value: rows.NET_INCOME_TITLE,
    alias: rows.NET_INCOME_ALIAS,
    hidden: false,
    readOnly: true,
    format: largeCurrencyFormat,
    gridType: 'number',
    dbType: 'string',
    className: INDENTED_BOLD_CLASSNAME,
    validExpr: rows.NET_INCOME_EXPR,
    allowEmptyValue: true,
    skipIfNullProviders: true,
  },
];

export default rowConfig;
